import { render, staticRenderFns } from "./ModalEvento.vue?vue&type=template&id=5f5048db&"
import script from "./ModalEvento.vue?vue&type=script&lang=js&"
export * from "./ModalEvento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports